import type { LeaderboardList, CasinoList } from './api'

export interface NavItem {
  key: string
  emoji: string
  name: string
  alt_name?: string
  route: string
}

// Single source of truth for the Sidebar's "Extras" section — also rendered in
// NavDropdown so it stays in sync without needing to be listed in two places.
export const EXTRAS_NAV_ITEMS: NavItem[] = [
  { key: 'nav:shop',            emoji: '🛒', name: 'Shop',            route: '/shop' },
  { key: 'nav:gift',            emoji: '🎁', name: 'Bribes',            route: '/gift' },
  { key: 'nav:loans',           emoji: '🐀', name: 'Loans',           route: '/loans' },
  { key: 'nav:fantasy-dungeon-league', emoji: '🧙', name: 'FDL', route: '/fantasy-dungeon-league' },
  { key: 'nav:cheese-singularity', emoji: '🕳️', name: 'Cheese Singularity', route: '/cheese-singularity' },
  { key: 'nav:unemployment',    emoji: '🧀', name: 'Unemployment Form', route: '/unemployment' },
  { key: 'nav:newsletter',      emoji: '📰', name: 'Newsletter',       route: '/newsletter' },
]

const STATIC_NAV_ITEMS: NavItem[] = [
  { key: 'nav:home',              emoji: '🏠', name: 'Home',              route: '/' },
  { key: 'nav:profile',           emoji: '👤', name: 'Profile',           route: '' },  // route filled dynamically
  ...EXTRAS_NAV_ITEMS,
  { key: 'nav:collectibles:dinos',emoji: '🦖', name: 'Dino Garage',       route: '/collectibles?tab=dinos' },
  { key: 'nav:collectibles:cards',emoji: '🃏', name: 'Card Binder',       route: '/collectibles?tab=binder' },
  { key: 'nav:settings',          emoji: '⚙️', name: 'Settings',          route: '/settings' },
  { key: 'nav:admin',             emoji: '🛠️', name: 'Admin Panel',       route: '/admin' },
  { key: 'nav:dev-settings',      emoji: '🔑', name: 'Developer Settings',route: '/settings?tab=developer' },
  { key: 'nav:about',             emoji: '📐', name: 'About',             route: '/about' },
  { key: 'nav:credits',           emoji: '🎬', name: 'Credits',           route: '/credits' },
]

export function buildNavRegistry(
  leaderboardList: LeaderboardList,
  casinoList: CasinoList,
  username?: string,
): Map<string, NavItem> {
  const registry = new Map<string, NavItem>()

  for (const item of STATIC_NAV_ITEMS) {
    const resolved = item.key === 'nav:profile' && username
      ? { ...item, route: `/profile/${encodeURIComponent(username)}` }
      : item
    registry.set(resolved.key, resolved)
  }

  for (const board of leaderboardList.boards) {
    const key = `leaderboard:${board.key}`
    registry.set(key, { key, emoji: board.emoji, name: board.name, alt_name: board.alt_name, route: board.route })
  }

  for (const game of casinoList.games) {
    const key = `casino:${game.key}`
    registry.set(key, { key, emoji: game.emoji, name: game.name, alt_name: game.alt_name, route: game.route })
  }

  return registry
}
